import { MASONRY, RegionSelectionHome } from '@highmark-web/highmark-common';
import { RecentClaimsCardList } from '@leagueplatform/claims';
import {
  ActivityStackWidgetV2,
  HealthJourneyHome,
  HEALTH_JOURNEY_NAMESPACE,
  HEALTH_JOURNEY_NODE_TYPES,
} from '@leagueplatform/health-journey';
import {
  MasonryDriverNodeRenderersRegistry,
  MasonryWSDriverNodeRenderersRegistry,
} from '@leagueplatform/masonry';

export const initAppMasonryRegistry = () => {
  MasonryWSDriverNodeRenderersRegistry.overrideRenderer(
    HEALTH_JOURNEY_NAMESPACE,
    HEALTH_JOURNEY_NODE_TYPES.ACTIVITIES_WIDGET,
    ActivityStackWidgetV2,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.MODULE_KEY_CLAIMS,
    MASONRY.CUSTOM_WIDGET_TYPE_CLAIMS,
    RecentClaimsCardList,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.MODULE_KEY_HEALTH_JOURNEY,
    MASONRY.CUSTOM_WIDGET_TYPE_HEALTH_JOURNEY,
    HealthJourneyHome,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.MODULE_KEY_CUSTOM_WIDGETS,
    MASONRY.CUSTOM_WIDGET_REGION_BANNER,
    RegionSelectionHome,
  );
};
